//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApexCharts from 'apexcharts'
// import XLSX from 'xlsx' // import xlsx
import {
  saveAs
} from 'file-saver'
import axios from 'axios'
import '@/mixins/global'
import moment from 'moment'
export default {
  data () {
    let objectDate = new Date()
    let day = objectDate.getDate()
    console.log(day)
    let month = objectDate.getMonth()
    // eslint-disable-next-line no-unused-expressions
    month = month + 1
    let year = objectDate.getFullYear()
    if (day < 10) {
      day = '0' + day
    }
    if (month < 10) {
      month = `0${month}`
    }
    let format1 = `${day}/${month}/${year}`
    return {

      table_detail: [],
      show_table: false,
      exoprt_open: false,
      date: format1,
      ex_date_from: format1,
      ex_date_to: format1,
      ex_V_so_no: '',
      date_from: format1,
      date_to: format1,
      open_detail: false,
      model_data_type: 'SUMMARY',
      option_data: ['SUMMARY', 'DETAIL'],
      model_date_type: 'CUT DATE',
      option_date: ['CUT DATE', 'SEW DATE'],
      chart_data_global: {},
      min_date_14: '',
      date_so: [],
      json_exce: [],
      raw_date_so: [],
      btn_target: 'Late',
      btn_set: 'LATE',
      count_complete_total: 0,
      count_complete: 0,
      count_not_complete: 0,
      count_late: 0,
      count_alert: 0,
      count_normal: 0,
      // eslint-disable-next-line no-undef
      count_reload: 0,
      V_so_year: '',
      V_so_no: '',
      options_tab: [{
        label: 'LATE',
        value: 'Late'
      },
      {
        label: 'ALERT',
        value: 'Alert'
      },
      {
        label: 'NORMAL',
        value: 'Normal'
      }
      ],
      visible: true,
      data_chart: {
        category: ['AUTO', 'MANUAL', 'STRIPE'],
        target: [],
        plan: [],
        actual: [],
        ptt: [],
        ptp: [],
        cp: []
      },
      columns_detail: [{
        field: 'QUEUE_NO',
        name: 'QUEUE_NO',
        label: 'Queue',
        align: 'center',
        sortable: true
      },
      {
        field: 'PLAN_TABLE',
        name: 'PLAN_TABLE',
        label: 'Plan table',
        align: 'center',
        sortable: true
      },
      {
        field: 'GROUP_MC',
        name: 'GROUP_MC',
        label: 'Group',
        align: 'center',
        sortable: true
      },
      // {
      //   field: "MC_TYPE",
      //   name: "MC_TYPE",
      //   label: "MC Type.",
      //   align: "center",
      //   sortable: true
      // },
      {
        field: 'TABLE_GM',
        name: 'TABLE_GM',
        label: 'Table',
        align: 'center',
        sortable: true
      },
      {
        field: 'SO_NO',
        name: 'SO_NO',
        label: 'SO No.',
        align: 'right',
        sortable: true
      },
      {
        field: 'GMT',
        name: 'GMT',
        label: 'Product',
        align: 'center',
        sortable: true
      },
      {
        field: 'STYLE_REF',
        name: 'STYLE_REF',
        label: 'Style',
        align: 'left',
        sortable: true
      },
      {
        field: 'SUB_PROCESS',
        name: 'SUB_PROCESS',
        label: 'Sub-Process',
        align: 'center',
        sortable: true
      },
      {
        field: 'FABRIC_TYPE',
        name: 'FABRIC_TYPE',
        label: 'Fabric',
        align: 'left',
        sortable: true
      },
      {
        field: 'GM_NO',
        name: 'GM_NO',
        label: 'GM-08',
        align: 'left',
        sortable: true
      },
      {
        field: 'PART_NO',
        name: 'PART_NO',
        label: 'Part',
        align: 'center',
        sortable: true
      },
      {
        field: 'RATIO',
        name: 'RATIO',
        label: 'Ratio',
        align: 'right',
        sortable: true
      },
      {
        field: 'PERI',
        name: 'PERI',
        label: 'Peri.',
        align: 'right',
        sortable: true
      },
      {
        field: 'PLY',
        name: 'PLY',
        label: 'Ply',
        align: 'right',
        sortable: true
      },
      {
        field: 'TOTAL_PCS',
        name: 'TOTAL_PCS',
        label: 'Total PCs.',
        align: 'right',
        sortable: true
      },
      {
        field: 'MARK_LENGTH',
        name: 'MARK_LENGTH',
        label: 'Maker length',
        align: 'right',
        sortable: true
      }
      ],
      filter: '',
      V_locations: 'G1',
      locations: ['G1', 'G2', 'G3', 'G4', 'VN1', 'VN2', 'TRM'], // 'VN1', 'VN2', 'TRM'
      header_data_total: [],
      header_data_body: [],
      detail_data: [],
      number_length: false,
      select_option: 'ALL',
      optionsx: ['ALL', 'AUTO', 'BULK'],
      btn_show_detail: false
    }
  },
  watch: {
    btn_target (val) {
      alert(val)
    }
  },
  mounted () {
    // this.chart_data()
    this.onload_data()
    setInterval(this.onload_data, 900000)
  },
  methods: {
    click_hide_table (val) {
      // eslint-disable-next-line eqeqeq
      if (val == true) {
        // eslint-disable-next-line no-unused-expressions
        this.show_table = false
      } else {
        // eslint-disable-next-line no-unused-expressions
        this.show_table = true
      }
    },
    // eslint-disable-next-line camelcase
    Excel_Detail () {
      // eslint-disable-next-line camelcase
      let so_no = this.ex_V_so_no
      this.visible = true
      // eslint-disable-next-line camelcase this.$apiFix + 'cut_plan_new.php/export',
      this.detail_data = []
      // eslint-disable-next-line camelcase
      let path_api = 'http://127.0.0.1:9000/nygcontrolroom_x/api/'
      // eslint-disable-next-line camelcase
      path_api = this.$apiFix
      const params = new FormData()
      params.append('org', this.V_locations)
      params.append('model_date_type', this.model_date_type)
      params.append('date_from', this.ex_date_from)
      params.append('date_to', this.ex_date_to)
      params.append('so_no', so_no)
      params.append('export_type', this.model_data_type)
      void axios({
        method: 'post',
        // eslint-disable-next-line camelcase
        url: `${path_api}plan_cut_chart.php/Excel_Detail`,
        // url: this.$api + 'plan_cut_chart.php/Load_so_no',
        data: params
      })
        .then(res => {
          console.log(res.data)
          if (res.data.dt_sql.length > 0) {
            this.json_excel = res.data.dt_sql
            this.onExport()
          } else {
            alert('Please Check SO NO OR Check Date')
          }

          this.visible = false
        })
        .catch(error => {
          alert(error)
        })
    },
    open_export_Ex () {
      let objectDate = new Date()
      let day = objectDate.getDate()
      console.log(day)
      let month = objectDate.getMonth()
      // eslint-disable-next-line no-unused-expressions
      month = month + 1
      let year = objectDate.getFullYear()
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = `0${month}`
      }
      let format1 = `${day}/${month}/${year}`

      this.ex_date_from = format1
      this.ex_date_to = format1
      this.ex_V_so_no = ''
      this.exoprt_open = true
    },
    onExport () {
      /* const dataWS = XLSX.utils.json_to_sheet(this.json_excel)
            const wbb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wbb, dataWS)
            XLSX.writeFile(wbb, 'export.xlsx')
            return */
      // eslint-disable-next-line camelcase
      let key_name = Object.keys(this.json_excel[0])
      // eslint-disable-next-line camelcase
      let columns_width = []
      console.log(key_name)
      const ExcelJS = require('exceljs')
      const wb = new ExcelJS.Workbook()
      const ws = wb.addWorksheet('My Sheet')

      // eslint-disable-next-line camelcase
      let col_num = 1
      key_name.forEach(e => {
        columns_width.push({
          width: 20
        })
        ws.getCell(1, col_num).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: 'E0E0E0'
          }
        }
        ws.getCell(1, col_num).value = e
        ws.getCell(1, col_num).font = {
          family: 4,
          size: 14,
          underline: true,
          bold: true
        }
        ws.getCell(1, col_num).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        }

        // eslint-disable-next-line camelcase
        col_num++
      })
      // eslint-disable-next-line camelcase
      let row_num = 2
      // eslint-disable-next-line camelcase, no-unused-vars
      this.json_excel.forEach(x => {
        // eslint-disable-next-line camelcase, no-unused-vars
        let col_body = 1
        key_name.forEach(e => {
          if (parseInt(x.SUM_COMPLETE) > 0) {
            ws.getCell(row_num, col_body).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {
                argb: '99FF99'
              }
            }
          }
          // eslint-disable-next-line camelcase, no-undef SYSITSDADMIN
          ws.getCell(row_num, col_body).value = x[e]
          // row[col]
          ws.getCell(row_num, col_body).font = {
            family: 4,
            size: 14,
            underline: true
          }
          ws.getCell(row_num, col_body).alignment = {
            vertical: 'middle',
            horizontal: 'center'
          }
          // eslint-disable-next-line camelcase, no-undef
          col_body++
        })

        // eslint-disable-next-line camelcase
        row_num++
        // eslint-disable-next-line camelcase
        col_body = 1
      })

      // this.ex_date_from
      // this.ex_date_to

      // eslint-disable-next-line camelcase
      ws.columns = columns_width
      wb.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        saveAs(blob, 'EXPORT_PLAN_CUT_(' + this.ex_date_from + ')_' + this.model_data_type + '.xlsx')
      })
    },
    optionsFn1_date_ex (date) {
      let DATE_TO = moment(this.ex_date_to, 'DD/MM/YYYY').format('YYYY/MM/DD')
      // eslint-disable-next-line no-undef
      // let SYSDATE = moment().format('YYYY/MM/DD')
      return date <= DATE_TO
    },
    optionsFn2_date_ex (date) {
      let DATE_FROM = moment(this.ex_date_from, 'DD/MM/YYYY').format('YYYY/MM/DD')
      // eslint-disable-next-line no-undef
      // let SYSDATE = moment().format('YYYY/MM/DD')
      return date >= DATE_FROM
    },
    optionsFn1_date (date) {
      let DATE_TO = moment(this.date_to, 'DD/MM/YYYY').format('YYYY/MM/DD')
      // eslint-disable-next-line no-undef
      // let SYSDATE = moment().format('YYYY/MM/DD')
      return date <= DATE_TO
    },
    optionsFn2_date (date) {
      let DATE_FROM = moment(this.date_from, 'DD/MM/YYYY').format('YYYY/MM/DD')
      // eslint-disable-next-line no-undef
      // let SYSDATE = moment().format('YYYY/MM/DD')
      return date >= DATE_FROM
    },
    btn_group (text) {
      // eslint-disable-next-line no-debugger
      // debugger
      this.btn_set = text
      this.btn_show_detail = false
      // eslint-disable-next-line camelcase, eqeqeq
      let dt_filter = this.raw_date_so.filter((e) => e.KEY_SEW_DATE == text)
      // eslint-disable-next-line camelcase
      this.date_so = dt_filter
      console.log(dt_filter)
      // this.raw_date_so
      // this.date_so
      // const filtered = this.raw_date_so.filter(([key, value]) => typeof value === 'string');
    },
    async onload_data () {
      this.visible = true
      this.data_chart.target = []
      this.data_chart.plan = []
      this.data_chart.actual = []
      this.data_chart.ptt = []
      this.data_chart.ptp = []
      this.data_chart.cp = []
      // eslint-disable-next-line camelcase
      this.header_data_body = []
      this.header_data_total = []
      this.chart_data_global = {
        team: [],
        target: [],
        plan: [],
        actual: [],
        ptt: [],
        ptp: [],
        performance: []
      }
      // eslint-disable-next-line camelcase
      const params = new FormData()
      params.append('org', this.V_locations)
      params.append('date', this.date_from)
      params.append('date_from', this.date_from)
      params.append('date_to', this.date_to)
      params.append('so_no', this.V_so_no)
      params.append('so_year', this.V_so_year)
      // eslint-disable-next-line camelcase
      const res_head = await axios({
        method: 'post',
        url: `${this.$apiFix}plan_cut_chart.php/Load_head`,
        data: params
      })
      // eslint-disable-next-line camelcase
      console.log(res_head.data.dt_sql)
      console.log(res_head.data)
      if (res_head.data.dt_sql.length > 0) {
        // eslint-disable-next-line camelcase
        let date_head = res_head.data.dt_sql
        this.visible = false
        // eslint-disable-next-line camelcase, no-unused-vars
        let row_position = 0
        // eslint-disable-next-line camelcase, no-unused-vars
        let sum_targetN = 0
        // eslint-disable-next-line camelcase
        let sum_planN = 0
        // eslint-disable-next-line camelcase
        let sum_actualN = 0
        date_head.forEach(e => {
          this.header_data_body.push({
            TEAM: e.TEAM,
            TARGET: e.TARGET_TEAM,
            PLAN: e.PLAN_SUM,
            ACTUAL: e.ACTUAL_TEAM,
            PLAN_TO_TARGET: e.PLAN_TO_TARGET,
            CUT_PTP: e.PTP,
            CUT_PERFORMANCE: e.PERFORMANCE
          })
          // eslint-disable-next-line no-unused-expressions, no-sequences
          this.chart_data_global.team[row_position] = 'TEAM' + e.TEAM,
          // eslint-disable-next-line no-unused-expressions
          this.chart_data_global.target[row_position] = parseFloat(e.TARGET_TEAM.replace('%', ''))
          // eslint-disable-next-line no-unused-expressions
          this.chart_data_global.plan[row_position] = parseFloat(e.PLAN_SUM.replace('%', ''))
          // eslint-disable-next-line no-unused-expressions
          this.chart_data_global.actual[row_position] = parseFloat(e.ACTUAL_TEAM.replace('%', ''))
          // eslint-disable-next-line no-unused-expressions
          this.chart_data_global.ptt[row_position] = parseFloat(e.PLAN_TO_TARGET.replace('%', ''))
          // eslint-disable-next-line no-unused-expressions
          this.chart_data_global.ptp[row_position] = parseFloat(e.PTP.replace('%', ''))
          // eslint-disable-next-line no-unused-expressions
          this.chart_data_global.performance[row_position] = parseFloat(e.PERFORMANCE.replace('%', ''))
          // eslint-disable-next-line camelcase
          row_position++
          // eslint-disable-next-line camelcase
          sum_targetN = parseFloat(sum_targetN) + parseFloat(e.TARGET_TEAM)
          // eslint-disable-next-line camelcase
          sum_planN = parseFloat(sum_planN) + parseFloat(e.PLAN_SUM)
          // eslint-disable-next-line camelcase
          sum_actualN = parseFloat(sum_actualN) + parseFloat(e.ACTUAL_TEAM)
        })
        this.header_data_total.push({
          TEAM: 'TOTAL',
          CUT_DATE: '',
          // eslint-disable-next-line no-use-before-define
          TARGET: sum_targetN.toFixed(2),
          // eslint-disable-next-line no-use-before-define
          PLAN: sum_planN.toFixed(2),
          // eslint-disable-next-line no-use-before-define
          ACTUAL: sum_actualN.toFixed(2),
          // eslint-disable-next-line no-use-before-define, camelcase
          PLAN_TO_TARGET: ((sum_planN / sum_targetN) * 100).toFixed(2),
          // eslint-disable-next-line no-use-before-define, camelcase
          CUT_PTP: ((sum_actualN / sum_planN) * 100).toFixed(2),
          // eslint-disable-next-line no-use-before-define, camelcase
          CUT_PERFORMANCE: ((sum_actualN / sum_targetN) * 100).toFixed(2),
          LOCATION: ''
        })
        console.log(this.chart_data_global)
        this.chart_data2()
        // eslint-disable-next-line camelcase
      }

      // eslint-disable-next-line camelcase
      const res_min_date = await axios({
        method: 'post',
        url: `${this.$apiFix}plan_cut_chart.php/Load_min_date`,
        data: params
      })
      if (res_min_date.data.dt_sql.length > 0) {
        // eslint-disable-next-line camelcase
        let min_date = res_min_date.data.dt_sql[0]['MIN_START_SEW']
        // eslint-disable-next-line camelcase
        this.min_date_14 = min_date
        console.log(min_date)
        console.log(res_min_date)
        console.log(min_date)

        await this.LoadData()
        await this.Loadtable_detail()
      }
    },
    check_zero (val) {
      if (val > 0) {
        return true
      } else {
        return false
      }
    },
    check_zero_so (val) {
      if (val > 0) {
        return false
      } else {
        return false
      }
    },
    async search_so () {
      // date
      // this.V_so_no = ''
      this.$refs.qDateProxy.hide()
      await this.LoadData()
      await this.Load_head()
    },
    // eslint-disable-next-line camelcase
    async showinputdate (text_val) {
      // date
      // this.visible = true
      // this.V_so_no = ''
      // this.V_so_year = ''
      // eslint-disable-next-line camelcase, eqeqeq
      if (text_val == 'from') {
        this.$refs.qDateProxy_from.hide()
      } else {
        this.$refs.qDateProxy_to.hide()
      }
      /* await this.LoadData()
            await this.Load_head() */
    },
    // eslint-disable-next-line camelcase
    async showinputdate_ex (text_val) {
      // date
      // this.visible = true
      // this.V_so_no = ''
      // this.V_so_year = ''
      // eslint-disable-next-line camelcase, eqeqeq
      if (text_val == 'from') {
        this.$refs.qDateProxy_from_ex.hide()
      } else {
        this.$refs.qDateProxy_to_ex.hide()
      }
      /* await this.LoadData()
            await this.Load_head() */
    },
    // eslint-disable-next-line camelcase
    keypress_length (event, val, type_text) {
      // eslint-disable-next-line camelcase, eqeqeq
      if (type_text == 'YEAR') {
        if (val.length > 1) {
          return event.preventDefault()
        }
      } else {
        if (val.length > 3) {
          return event.preventDefault()
        }
      }
    },
    chart_data2 () {
      // eslint-disable-next-line camelcase
      let max_target = Math.max.apply(null, this.chart_data_global.target.map(e => parseInt(e)))
      // eslint-disable-next-line camelcase
      let max_plan = Math.max.apply(null, this.chart_data_global.plan.map(e => parseInt(e)))
      // eslint-disable-next-line camelcase
      let max_actual = Math.max.apply(null, this.chart_data_global.actual.map(e => parseInt(e)))
      // eslint-disable-next-line camelcase
      let max_ptt = Math.max(max_target, max_plan)
      // eslint-disable-next-line camelcase
      let max_ptp = Math.max(max_actual, max_plan)
      // eslint-disable-next-line camelcase
      let max_perfromance = Math.max(max_actual, max_target)
      var optionsLine1 = {
        colors: ['#2E93fA', '#66DA26', '#b30000'],
        series: [{
          name: 'TARGET(MIN)',
          type: 'column',
          data: []
        },
        {
          name: 'PLAN(MIN)',
          type: 'column',
          data: []
        },
        {
          name: 'PERCENT(%)',
          type: 'line',
          data: []
        }
        ],
        chart: {
          height: 230,
          type: 'line',
          stacked: false,
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            columnWidth: '60%'
          }
        },
        stroke: {
          width: [0, 0, 3]
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            // eslint-disable-next-line eqeqeq
            if (opts.seriesIndex == 2) {
              return val + '%'
            }
            return val
          }
        },
        title: {
          text: 'Cut Plan to Target'.toUpperCase(),
          align: 'center'
          // offsetX: 110
        },
        xaxis: {
          categories: this.chart_data_global.team
        },
        yaxis: [{
          seriesName: 'TARGET',
          axisTicks: {
            show: true
          },
          max: max_ptt,
          // max: Math.max(chart_data.target[0], chart_data.target[1], chart_data.target[2]),
          // eslint-disable-next-line camelcase
          // logBase: (max_yx / 5),
          tickAmount: 5,
          axisBorder: {
            show: true,
            color: '#008FFB'
          },
          labels: {
            style: {
              colors: '#008FFB'
            }
          },
          offsetX: -5,
          title: {
            text: 'Target min'.toUpperCase(),
            style: {
              color: '#008FFB'
            }
          },
          tooltip: {
            enabled: true
          }
        },
        {
          seriesName: 'PLAN',
          show: false,
          opposite: false,
          axisTicks: {
            show: true
          },
          max: max_ptt,
          tickAmount: 5,
          axisBorder: {
            show: false,
            color: '#00E396'
          },
          labels: {
            style: {
              colors: '#00E396'
            },
            offsetX: -10
          },
          title: {
            text: 'Operating Cashflow (thousand crores)',
            style: {
              color: '#00E396'
            }
          }
        },
        {
          show: true,
          seriesName: 'PER',
          opposite: true,
          axisTicks: {
            show: false
          },
          min: 0,
          max: 100,
          tickAmount: 5,
          axisBorder: {
            show: false,
            color: '#b30000'
          },
          labels: {
            style: {
              colors: '#b30000'
            },
            offsetX: -10,
            formatter: value => {
              return `${value}%`
            }
          },
          title: {
            text: 'percent Plan to Target (%)'.toUpperCase(),
            style: {
              color: '#b30000'
            }
          }
        }
        ],
        tooltip: {
          fixed: {
            enabled: false,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          }
        },
        legend: {
          horizontalAlign: 'left',
          offsetX: 40
        }
      }
      // eslint-disable-next-line no-undef
      var chart1 = new ApexCharts(
        document.getElementById('chart1'),
        optionsLine1
      )
      chart1.render()
      var optionsLine2 = {
        colors: ['#50e991', '#00bfa0', '#b30000'],
        series: [{
          name: 'PLAN(MIN)',
          type: 'column',
          data: []
        },
        {
          name: 'ACTUAL(MIN)',
          type: 'column',
          data: []
        },
        {
          name: 'PERCENT(%)',
          type: 'line',
          data: []
        }
        ],
        plotOptions: {
          bar: {
            columnWidth: '60%'
          }
        },
        chart: {
          height: 230,
          type: 'line',
          stacked: false,
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: [0, 0, 3]
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            // eslint-disable-next-line eqeqeq
            if (opts.seriesIndex == 2) {
              return val + '%'
            }
            return val
          }
        },
        title: {
          text: 'CUT PTP%',
          align: 'center'
        },
        xaxis: {
          categories: this.chart_data_global.team
        },
        yaxis: [{
          seriesName: 'TARGET',
          axisTicks: {
            show: true
          },
          max: max_ptp,
          // max: Math.max(chart_data.plan[0], chart_data.plan[1], chart_data.plan[2]),
          // logBase: 110,
          tickAmount: 5,
          axisBorder: {
            show: true,
            color: '#008FFB'
          },
          labels: {
            style: {
              colors: '#008FFB'
            }
          },
          title: {
            text: 'Plan min'.toUpperCase(),
            style: {
              color: '#008FFB'
            }
          },
          tooltip: {
            enabled: true
          }
        },
        {
          seriesName: 'PLAN',
          show: false,
          opposite: false,
          axisTicks: {
            show: true
          },
          max: max_ptp,
          tickAmount: 5,
          axisBorder: {
            show: false,
            color: '#00E396'
          },
          labels: {
            style: {
              colors: '#00E396'
            },
            offsetX: -10
          },
          title: {
            text: 'Operating Cashflow (thousand crores)',
            style: {
              color: '#00E396'
            }
          }
        },
        {
          show: true,
          seriesName: 'PER',
          opposite: true,
          axisTicks: {
            show: false
          },
          max: 100,
          min: 0,
          tickAmount: 5,
          axisBorder: {
            show: false,
            color: '#b30000'
          },
          labels: {
            style: {
              colors: '#b30000'
            },
            offsetX: -5,
            formatter: value => {
              return `${value}%`
            }
          },
          title: {
            text: 'percent Plan to Actual (%)'.toUpperCase(),
            style: {
              color: '#b30000'
            }
          }
        }
        ],
        tooltip: {
          fixed: {
            enabled: false,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          }
        },
        legend: {
          horizontalAlign: 'left',
          offsetX: 40
        }
      }
      // eslint-disable-next-line no-undef, no-redeclare
      var chart2 = new ApexCharts(
        document.getElementById('chart2'),
        optionsLine2
      )
      chart2.render()

      var optionsLine3 = {
        colors: ['#1a53ff', '#4421af', '#b30000'],
        series: [{
          name: 'TARGET(MIN)',
          type: 'column',
          data: []
        },
        {
          name: 'ACTUAL(MIN)',
          type: 'column',
          data: []
        },
        {
          name: 'PERCENT(%)',
          type: 'line',
          data: []
        }
        ],
        chart: {
          height: 230,
          type: 'line',
          stacked: false,
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: [0, 0, 3]
        },
        plotOptions: {
          bar: {
            columnWidth: '60%'
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            // eslint-disable-next-line eqeqeq
            if (opts.seriesIndex == 2) {
              return val + '%'
            }
            return val
          }
        },
        title: {
          text: 'Cut Performance%'.toUpperCase(),
          align: 'center'
        },
        xaxis: {
          categories: this.chart_data_global.team
        },
        yaxis: [{
          seriesName: 'TARGET',
          axisTicks: {
            show: true
          },
          // max: Math.max(chart_data.target[0], chart_data.target[1], chart_data.target[2]),
          // logBase: 120,
          // max: 600,
          max: max_perfromance,
          tickAmount: 5,
          axisBorder: {
            show: true,
            color: '#008FFB'
          },
          labels: {
            style: {
              colors: '#008FFB'
            }
          },
          title: {
            text: 'Target min'.toUpperCase(),
            style: {
              color: '#008FFB'
            }
          },
          tooltip: {
            enabled: true
          }
        },
        {
          seriesName: 'PLAN',
          show: false,
          opposite: false,
          axisTicks: {
            show: true
          },
          max: max_perfromance,
          tickAmount: 5,
          axisBorder: {
            show: false,
            color: '#00E396'
          },
          labels: {
            style: {
              colors: '#00E396'
            },
            offsetX: -10
          },
          title: {
            text: 'Operating Cashflow (thousand crores)',
            style: {
              color: '#00E396'
            }
          }
        },
        {
          show: true,
          seriesName: 'PER',
          opposite: true,
          axisTicks: {
            show: false
          },
          max: 100,
          min: 0,
          logBase: 20,
          tickAmount: 5,
          axisBorder: {
            show: false,
            color: '#b30000'
          },
          labels: {
            style: {
              colors: '#b30000'
            },
            offsetX: -5,
            formatter: value => {
              return `${value}%`
            }
          },
          title: {
            text: 'percent Target to ACTUAL (%)'.toUpperCase(),
            style: {
              color: '#b30000'
            }
          }
        }
        ],
        tooltip: {
          fixed: {
            enabled: false,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          }
        },
        legend: {
          horizontalAlign: 'left',
          offsetX: 40
        }
      }
      // eslint-disable-next-line no-undef, no-redeclare
      var chart3 = new ApexCharts(
        document.getElementById('chart3'),
        optionsLine3
      )
      chart3.render()

      // #1
      chart1.updateSeries([{
        name: 'TARGET(MIN)',
        type: 'column',
        data: this.chart_data_global.target
      },
      {
        name: 'PLAN(MIN)',
        type: 'column',
        data: this.chart_data_global.plan
      },
      {
        name: 'PERCENT(%)',
        type: 'line',
        data: this.chart_data_global.ptt
      }
      ])
      // #2
      chart2.updateSeries([{
        name: 'PLAN(MIN)',
        type: 'column',
        data: this.chart_data_global.plan
      },
      {
        name: 'ACTUAL(MIN)',
        type: 'column',
        data: this.chart_data_global.actual
      },
      {
        name: 'PERCENT(%)',
        type: 'line',
        data: this.chart_data_global.ptp
      }
      ])
      // #3
      chart3.updateSeries([{
        name: 'TARGET(MIN)',
        type: 'column',
        data: this.chart_data_global.target
      },
      {
        name: 'ACTUAL(MIN)',
        type: 'column',
        data: this.chart_data_global.actual
      },
      {
        name: 'PERCENT(%)',
        type: 'line',
        data: this.chart_data_global.performance
      }
      ])
    },
    LoadData () {
      this.count_late = 0
      this.count_alert = 0
      this.count_normal = 0
      this.visible = true
      this.date_so = []
      // eslint-disable-next-line camelcase
      let path_api = 'http://127.0.0.1:9000/nygcontrolroom_x/api/'
      // eslint-disable-next-line camelcase
      path_api = this.$apiFix
      const params = new FormData()
      params.append('min_date_14', this.min_date_14)
      params.append('org', this.V_locations)
      params.append('date', this.date_from)
      params.append('date_from', this.date_from)
      params.append('date_to', this.date_to)
      params.append('so_no', this.V_so_no)
      params.append('so_year', this.V_so_year)
      void axios({
        method: 'post',
        // eslint-disable-next-line camelcase
        url: `${path_api}plan_cut_chart.php/Load_so_no`,
        // url: this.$api + 'plan_cut_chart.php/Load_so_no',
        data: params
      })
        .then(res => {
          console.log(res.data)
          this.raw_date_so = res.data.dt_sql
          this.date_so = res.data.dt_sql
          this.visible = false
          if (res.data.dt_sql.length > 0) {
            res.data.dt_sql.forEach(e => {
              // eslint-disable-next-line eqeqeq
              if (e.KEY_SEW_DATE == 'LATE') {
                this.count_late++
              }
              // eslint-disable-next-line eqeqeq
              if (e.KEY_SEW_DATE == 'ALERT') {
                this.count_alert++
              }
              // eslint-disable-next-line eqeqeq
              if (e.KEY_SEW_DATE == 'NORMAL') {
                this.count_normal++
              }
            })

            this.btn_group('LATE')
          }
        })
        .catch(error => {
          alert(error)
        })
    },
    Load_head () {
      this.data_chart.target = []
      this.data_chart.plan = []
      this.data_chart.actual = []
      this.data_chart.ptt = []
      this.data_chart.ptp = []
      this.data_chart.cp = []
      // eslint-disable-next-line camelcase
      let path_api = 'http://127.0.0.1:9000/nygcontrolroom_x/api/'
      // eslint-disable-next-line camelcase
      this.header_data_body = []
      // eslint-disable-next-line camelcase
      path_api = this.$apiFix
      const params = new FormData()
      params.append('org', this.V_locations)
      params.append('date', this.date_from)
      params.append('date_from', this.date_from)
      params.append('date_to', this.date_to)
      params.append('so_no', this.V_so_no)
      params.append('so_year', this.V_so_year)
      void axios({
        method: 'post',
        // eslint-disable-next-line camelcase
        url: `${path_api}plan_cut_chart.php/Load_head`,
        // url: this.$api + 'plan_cut_chart.php/Load_so_no',
        data: params
      })
        .then(res => {
          console.log(res.data)
          // eslint-disable-next-line no-debugger
          // eslint-disable-next-line camelcase
          if (res.data.dt_sql.length > 0) {
            // eslint-disable-next-line camelcase
            let date_head = res.data.dt_sql[0]
            // eslint-disable-next-line camelcase
            let header_data = [{
              MC_TYPE: 'AUTO',
              CUT_DATE: date_head.CUT_DATE,
              TARGET: date_head.TAGET_AUTO,
              PLAN: date_head.PLAN_SUM_AUTO,
              ACTUAL: date_head.ACTUAL_AUTO,
              PLAN_TO_TARGET: date_head.PLAN_TO_TARGET_AUTO,
              CUT_PTP: date_head.PTP_AUTO,
              CUT_PERFORMANCE: date_head.PERFORMANCE_AUTO,
              LOCATION: date_head.ORG
            },
            {
              MC_TYPE: 'MANUAL',
              CUT_DATE: date_head.CUT_DATE,
              TARGET: date_head.TAGET_MANUAL,
              PLAN: date_head.PLAN_SUM_BULK,
              ACTUAL: date_head.ACTUAL_BULK,
              PLAN_TO_TARGET: date_head.PLAN_TO_TARGET_BULK,
              CUT_PTP: date_head.PTP_BULK,
              CUT_PERFORMANCE: date_head.PERFORMANCE_BULK,
              LOCATION: date_head.ORG
            },
            {
              MC_TYPE: 'STRIPE',
              CUT_DATE: date_head.CUT_DATE,
              TARGET: date_head.TAGET_STRIPE,
              PLAN: date_head.PLAN_SUM_STRIPE,
              ACTUAL: date_head.ACTUAL_STRIPE,
              PLAN_TO_TARGET: date_head.PLAN_TO_TARGET_STRIPE,
              CUT_PTP: date_head.PTP_STRIPE,
              CUT_PERFORMANCE: date_head.PERFORMANCE_STRIPE,
              LOCATION: date_head.ORG
            }
            ]
            // eslint-disable-next-line camelcase
            this.header_data_body = header_data
            console.log(header_data)
            // eslint-disable-next-line camelcase, no-unused-vars
            let sum_target = 0
            // eslint-disable-next-line camelcase, no-unused-vars
            let sum_plan = 0
            // eslint-disable-next-line camelcase
            let sum_actual = 0
            // eslint-disable-next-line no-debugger
            header_data.forEach(x => {
              // eslint-disable-next-line camelcase
              sum_target = sum_target + parseFloat(x.TARGET)
              // eslint-disable-next-line camelcase
              sum_plan = sum_plan + parseFloat(x.PLAN)
              // eslint-disable-next-line camelcase
              sum_actual = sum_actual + parseFloat(x.ACTUAL)
              this.data_chart.target.push(parseFloat(x.TARGET))
              this.data_chart.plan.push(parseFloat(x.PLAN))
              this.data_chart.actual.push(parseFloat(x.ACTUAL))
              this.data_chart.ptt.push(parseFloat(x.PLAN_TO_TARGET))
              this.data_chart.ptp.push(parseFloat(x.CUT_PTP))
              this.data_chart.cp.push(parseFloat(x.CUT_PERFORMANCE))
            })

            // eslint-disable-next-line camelcase
            let header_data_total = [{
              MC_TYPE: 'TOTAL',
              TARGET: sum_target.toFixed(2),
              PLAN: sum_plan.toFixed(2),
              ACTUAL: sum_actual.toFixed(2),
              // eslint-disable-next-line camelcase
              PLAN_TO_TARGET: parseFloat((sum_plan / sum_target) * 100).toFixed(2),
              // eslint-disable-next-line camelcase
              CUT_PTP: parseFloat((sum_actual / sum_plan) * 100).toFixed(2),
              // eslint-disable-next-line camelcase
              CUT_PERFORMANCE: parseFloat((sum_actual / sum_target) * 100).toFixed(2)
            }]
            // eslint-disable-next-line camelcase
            this.header_data_total = header_data_total
            this.chart_data2()

            // eslint-disable-next-line eqeqeq
            if (this.count_reload == 0) {
              this.chart_data2()
              this.count_reload++
            } else {
              // eslint-disable-next-line no-undef
            }
            console.log(header_data_total)
            console.log(header_data_total)
          }
        })
        .catch(error => {
          alert(error)
        })
    },
    async Loadtable_detail () {
      this.visible = true
      let DATE_FROM = moment(this.ex_date_to, 'DD/MM/YYYY').format('YYYY/MM/DD')
      const timex = await this.gettime()
      const postjson = {
        authen: {
          keycode: this.$keycode
        },
        filter: {
          loc: this.V_locations, // 'G1', // V_locations
          mctype: 'ALL', // this.department,
          cutdate: DATE_FROM, // '2022/11/03', // RRRR/MM/DD
          time: timex // 1667460097
        }
      }
      console.log(postjson)
      const config = {
        method: 'post',
        url: this.$apiFix + 'cut_plan_new.php/detail',
        data: JSON.stringify(postjson)
      }

      const res = await axios(config)
      console.log(res.data.dsdata)
      try {
        if (res.data.dsdata.length > 0) {
          this.table_detail = res.data.dsdata
          this.visible = false
        } else {
          this.visible = false
        }
      } catch (err) {
        this.visible = false
      }

      /* method: 'post',
              url: this.$apiFix + 'cut_plan_new.php/detail',
              data: JSON.stringify(postjson) */
    },
    // eslint-disable-next-line camelcase
    LoadDataDetail (so_no, so_year) {
      this.visible = true
      this.count_complete_total = 0
      this.count_complete = 0
      this.count_not_complete = 0
      // eslint-disable-next-line camelcase this.$apiFix + 'cut_plan_new.php/export',
      this.detail_data = []
      // eslint-disable-next-line camelcase
      let path_api = 'http://127.0.0.1:9000/nygcontrolroom_x/api/'
      // eslint-disable-next-line camelcase
      path_api = this.$apiFix
      const params = new FormData()
      params.append('org', this.V_locations)
      params.append('date', this.date_from)
      params.append('date_from', this.date_from)
      params.append('date_to', this.date_to)
      params.append('so_no', so_no)
      params.append('so_year', so_year)
      void axios({
        method: 'post',
        // eslint-disable-next-line camelcase
        url: `${path_api}plan_cut_chart.php/LoadDataDetail`,
        // url: this.$api + 'plan_cut_chart.php/Load_so_no',
        data: params
      })
        .then(res => {
          console.log(res.data)
          this.detail_data = res.data.dt_sql
          this.visible = false
          // eslint-disable-next-line camelcase
          let comp = 0
          // eslint-disable-next-line camelcase
          let not_comp = 0
          let total = 0
          if (res.data.dt_sql.length > 0) {
            total = res.data.dt_sql.length
            res.data.dt_sql.forEach(e => {
              if (parseFloat(e.SUM_COMPLETE) > 0) {
                comp++
              } else {
                // eslint-disable-next-line camelcase
                not_comp++
              }
            })
          }

          this.count_complete_total = total
          // eslint-disable-next-line
                    this.count_complete = not_comp
          this.count_not_complete = comp
        })
        .catch(error => {
          alert(error)
        })
    }
  }
}
